<template>
  <div class="container">
    <div class="jiance_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="'../../../static/soil/data.html?token='+$store.state.user.token"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
    </div>
  </div>
</template>
<script>
export default {  
  data () {
    return {
      title: '',
      iframeUrl:''
    }
  },
  methods: {}
}
</script>
<style scoped>
.container {
	position: relative;
	width: 100%;
	height:100%;
	background:url('../../assets/soil_bg.jpg') no-repeat;
	background-size: cover;
}
.jiance_main{
	position: absolute;
	top:2px;
	left:0;
	right:0;
	bottom:0;
	overflow: hidden;
}

#iframeContain{
	width: 100%;
	height: 100%;
	border: 0;
	padding: 0;
	margin:0;
}
</style>